import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Paper, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { POINT_TYPE, PROFIL, REGEX_PR, REQUEST_PASS_STATUS, REQUEST_PASS_TYPE } from '../../../../constants/enum';
import Radio from '@mui/material/Radio';
import MyButton from '../../../Layout/MyButton';
import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AgGrid from '../../../AgGrid/AgGrid';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../../../Layout/TabPanel';
import axios from 'axios';
import { URL_API } from '../../../../utils/globalConfig';
import { logError } from '../../../Utils/FormatData';
import MySelect from '../../../Layout/MySelect';
import monProfil from '../../../../views/Compte/MonProfil';
import MyComboBox from '../../../Layout/MyComboBox';
import ControlledTextField from '../../../Controlled/RequestPass/ControlledTextField';
import { updateInfosCompl } from '../../../../actions/RequestPassAction';
import { useDispatch } from 'react-redux';

const elemPatriColumns = (index, handleChange, trajetDescr, retour) => {
    return [
        { headerName: 'id', field: 'id_oa', sortable: true, filter: 'agTextColumnFilter' },
        {
            headerName: 'description',
            field: 'description',
            sortable: false,
            resizable: true,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Type EP', field: 'type', sortable: true, filter: 'agSetColumnFilter', filterParams: {
                selectAllOnMiniFilter: true,
            },
        },
        { headerName: 'Info EP', field: 'info', sortable: true, filter: 'agTextColumnFilter' },
        {
            headerName: 'axe',
            field: 'axis',
            sortable: true,
            resizable: true,
            minWidth: 300,
            filter: 'agTextColumnFilter',
        },
        { headerName: 'sens', field: 'direction', sortable: false, filter: 'agNumberColumnFilter' },
        { headerName: 'pk', field: 'landmark', sortable: true, filter: 'agNumberColumnFilter' },
        { headerName: 'hauteur', field: 'airPulling', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter' },
        { headerName: 'longueur', field: 'length', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter' },
        { headerName: 'largeur', field: 'width', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter' },
        { headerName: 'ptac_max', field: 'weight', sortable: true, filter: 'agNumberColumnFilter' },
        { headerName: 'ptac_max_grue', field: 'ptac_grue', sortable: true, filter: 'agNumberColumnFilter' },
        { headerName: 'IGM', field: 'iti_grd_maille', sortable: true, filter: 'agNumberColumnFilter' },
        {
            headerName: 'PTAC/IGM',
            field: 'rapport_ptac_max',
            sortable: true,
            filter: 'agNumberColumnFilter',
            valueGetter: (params) => {
                let calcul = null;
                if (params.data.iti_grd_maille > 0) {
                    calcul = params.data.weight / params.data.iti_grd_maille;
                }
                return calcul ?? '-';
            }
        },
        { headerName: 'centre', field: 'center', sortable: true, filter: 'agSetColumnFilter', filterParams: {
                selectAllOnMiniFilter: true,
            },
        },
        { headerName: 'commune', field: 'commune', sortable: true, filter: 'agTextColumnFilter' },
        {
            headerName: 'actions',
            field: 'selected',
            minWidth: 200,
            sortable: false,
            cellRenderer: 'elemPatriActionRenderer',
            cellRendererParams: {
                index: index, trajetDescr: trajetDescr, setTrajetDescr: handleChange, retour: retour,
            },
            pinned: 'right',
        },
    ];
};
const css = {
    tab: { width: '130px' },
    tabPanel: { backgroundColor: '#F3F6F9', marginLeft: '-10px' },
};

const TrajetDescrComponent = (props) => {
    const {
        t, i, profil, demandePassageStyle, handleChange, handleChangeAccordion, requestPassId, requestPassStatus, handleChangeSectionCheckbox,
        descr, retour, trajetDescr, complInfo, notAbleToChange, tronconInPlanification,
        onOpenElemPatri, deleteSection, handleChangeSection, frameworkComponents, agGridOptions, setAgGridOptions, user,
        reference, isBuilding, ajouterEp
    } = props;

    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(t.expanded ?? true);
    const [centers, setCenters] = useState([]);
    const [axes, setAxes] = useState([]);
    const [centersSelected, setCentersSelected] = useState([]);
    const [axeSelected, setAxeSelected] = useState(null);
    const [value, setValue] = useState(Number(t.elemPatri.length > 0));
    const [pointTypes] = useState([
        'Diffuseur',
        'Noeud Autoroutier',
        'Accès de service',
        'Aire',
        'Limite de concession',
        'Autres',
    ]);
    const [pointCaracsEnter, setPointCaracsEnter] = useState([]);
    const [pointCaracsExit, setPointCaracsExit] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [listPrEnter, setListPrEnter] = useState([]);
    const [listPrExit, setListPrExit] = useState([]);

    useEffect(() => {
        apiGetListCenters();
        apiGetListAxes();
    }, []);

    useEffect(() => {
        let descrEl = { ...descr[i] };

        if ((descrEl.centres === null || descrEl.centres.length === 0) && descrEl.centre !== null)
            setCentersSelected([descrEl.centre]);
        else
            setCentersSelected(descrEl.centres);
    }, [centers]);

    useEffect(() => {
        let descrEl = { ...descr[i] };

        if (axes.length > 0) {
            setAxeSelected(descrEl.road);
        }
    }, [axes]);

    useEffect(() => {
        if (centersSelected) {
            handleChangeSection({
                target: {
                    name: 'centres',
                    value: centersSelected,
                },
            }, descr, i, retour ? 'descrRetour' : 'descr');
        }
    }, [centersSelected]);

    useEffect(() => {
        if (axeSelected) {
            handleChangeSection({
                target: {
                    name: 'road',
                    value: axeSelected,
                },
            }, descr, i, retour ? 'descrRetour' : 'descr');
        }
    }, [axeSelected]);

    useEffect(() => {
        if (t.expanded) {
            handleTabChange(null, Number(t.elemPatri.length > 0));
        }
        setExpanded(t.expanded);
    }, [t.expanded]);

    useEffect(() => {
        if (!t.numeroSection) {
            handleChangeSection({
                target: {
                    name: 'numeroSection',
                    value: (retour ? `R.${i + 1}` : `A.${i + 1}`),
                },
            }, descr, i, retour ? 'descrRetour' : 'descr');
        }
    }, [t]);

    useEffect(() => {
        if (!isLoading) {
            apiGetPointCaracs(t.pointTypeEnter, 'enter');
            apiGetPointCaracs(t.pointTypeExit, 'exit');
        }
    }, [isLoading]);

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => {
                setIsLoading(false);
            }, 800);
            return;
        }

        if (axeSelected) {
            if (t.pointTypeEnter) {
                apiGetPointCaracs(t.pointTypeEnter, 'enter');
            } else {
                apiGetPointCaracs(null, 'enter');
            }

            if (t.pointTypeExit) {
                apiGetPointCaracs(t.pointTypeExit, 'exit');
            } else {
                apiGetPointCaracs(null, 'exit');
            }
        } else {
            setPointCaracsEnter([]);
            setPointCaracsExit([]);
        }
    }, [axeSelected]);

    useEffect(() => {
        if (t.pointTypeEnter) {
            apiGetPointCaracs(t.pointTypeEnter, 'enter');
        } else if (axeSelected) {
            apiGetPointCaracs(null, 'enter');
        }
        setPointCaracsEnter([]);
    }, [t.pointTypeEnter]);

    useEffect(() => {
        if (t.pointTypeExit) {
            apiGetPointCaracs(t.pointTypeExit, 'exit');
        } else if (axeSelected) {
            apiGetPointCaracs(null, 'exit');
        }
        setPointCaracsExit([]);
    }, [t.pointTypeExit]);

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };
    const changeSelectValue = (value, setData, forCentre = false) => {

        if (forCentre) {
            manageInfoCompCentres(value);
        } else {
            setData(value);
        }
    };

    const manageInfoCompCentres = (centersIds) => {
        // region calcul ajout champs informations complémentaires
        let complInfoCenters = [...complInfo.refCtr];
        let newComplInfoCenters = [];
        let currentCenterIds = centersIds;

        trajetDescr.descr.map((descr) => {
            currentCenterIds = [...currentCenterIds, ...descr.centres];
        });

        trajetDescr.descrRetour.map((descr) => {
            currentCenterIds = [...currentCenterIds, ...descr.centres];
        });

        currentCenterIds = [...new Set(currentCenterIds.filter((id) => typeof id !== 'object'))];

        if (!retour) {
            trajetDescr.descr[i].centres.map((centerId) => {
                if (!centersIds.includes(centerId)) {
                    currentCenterIds = currentCenterIds.filter((id) => id !== centerId);
                }
            });
        } else {
            trajetDescr.descrRetour[i].centres.map((centerId) => {
                if (!centersIds.includes(centerId)) {
                    currentCenterIds = currentCenterIds.filter((id) => id !== centerId);
                }
            });
        }

        currentCenterIds.map((centerId) => {
            let centerExistLocally = false;

            complInfoCenters.map((infoCenter) => {
                if (Number(infoCenter.id) === Number(centerId)) {
                    newComplInfoCenters.push(infoCenter);
                    centerExistLocally = true;
                }
            });

            if (!centerExistLocally) {
                centers.map((center) => {
                    if (Number(center.id) === Number(centerId)) {
                        newComplInfoCenters.push({
                            id: centerId,
                            name: center.label,
                            comment: '',
                        });
                    }
                });
            }
        });

        dispatch(updateInfosCompl('refCtr', newComplInfoCenters));

        setCentersSelected(centersIds);
        // endregion
    };

    const apiGetListCenters = () => {
        axios({ method: 'get', url: `${URL_API}/localisation/list-centers`, params: { idRegion: null } })
        .then(function(response) {
            setCenters(response.data);
        })
        .catch(function(err) {
            logError(alert, err);
        });
    };

    const apiGetListAxes = () => {
        axios({ method: 'get', url: `${URL_API}/localisation/list-axes` })
        .then(function(response) {
            setAxes(response.data);
        })
        .catch(function(err) {
            logError(alert, err);
        });
    };

    const apiGetPointCaracs = (pointType, type) => {

        axios({
            method: 'get',
            url: `${URL_API}/localisation/list-point-caracs`,
            params: {
                axe: axeSelected ? axeSelected : '',
                pointType: pointType ? pointType : '',
            },
        })
        .then(function(response) {
            if (response.data) {
                if (type === 'enter')
                    setListPrEnter(response.data.map((item) => {
                        return { label: item[0], value: item[1] };
                    }));
                else if (type === 'exit')
                    setListPrExit(response.data.map((item) => {
                        return { label: item[0], value: item[1] };
                    }));
                if (isLoading) {
                    return;
                }
                response.data = response.data.map((item) => {
                    return item[0];
                });
                response.data = response.data.filter((item) => item !== null);

                if (type === 'enter')
                    setPointCaracsEnter(response.data);
                else if (type === 'exit')
                    setPointCaracsExit(response.data);
                else {
                    setPointCaracsEnter(response.data);
                    setPointCaracsExit(response.data);
                }
            }
        })
        .catch(function(err) {
            logError(alert, err);
        });
    };

    return (
        <Paper style={{
            ...demandePassageStyle.sectionPaper,
            height: 'fit-content',
            padding: ' 0px 0px 10px 20px',
            overflow: 'hidden',
        }} id={`section-paper-${t.numeroSection}`} key={`section-paper-${i + 1}`}>
            <Accordion expanded={expanded}>
                <AccordionSummary
                    style={{ width: '100%', padding: '0 20px', marginBottom: '20px', maxHeight: '150px' }}
                    expandIcon={<ExpandMoreIcon
                        className={'expand-more-icon'}
                        onClick={() => handleChangeAccordion(i, descr, retour ? 'descrRetour' : 'descr')}
                    />}>
                    <div className='row' style={{
                        ...demandePassageStyle.rowIntoPaper,
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: '100%',
                        maxHeight: 'none',
                    }}>
                        <ControlledTextField
                            label='N°'
                            type='text'
                            style={{
                                ...demandePassageStyle.textField, width: '5%',
                            }}
                            autoComplete='off'
                            name='numeroSection'
                            value={t.numeroSection ? t.numeroSection : (retour ? `R.${i + 1}` : `A.${i + 1}`)}
                            onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                            disabled={true}
                        />
                        <ControlledTextField
                            label='NOM TRONÇON'
                            type='text'
                            style={{
                                ...demandePassageStyle.textField, width: '20%',
                            }}
                            autoComplete='off'
                            name='nomSection'
                            value={t.nomSection || ''}
                            onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                            disabled={notAbleToChange}
                        />
                        <FormControl
                            style={{
                                margin: '20px',
                                display: (reference?.typeDemande === 'superieur' ? 'none' : 'block'),
                            }}>
                            <label>Passage :</label>
                            <RadioGroup name='passType' value={t.passType}
                                        style={{ display: 'flex', flexDirection: 'row' }}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}>
                                <FormControlLabel value={REQUEST_PASS_TYPE.SUPERIEUR} control={<Radio />}
                                                  label='PS'
                                                  disabled={notAbleToChange} />
                                <FormControlLabel value={REQUEST_PASS_TYPE.AUTOROUTE} control={<Radio />}
                                                  label='PA'
                                                  disabled={notAbleToChange} />
                            </RadioGroup>
                        </FormControl>
                        {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.CLIENT || profil.profil === PROFIL.GESTIONNAIRE) &&
                            <>
                                <FormControl
                                    style={{
                                        margin: '20px',
                                    }}>
                                    <label>Charge :</label>
                                    <RadioGroup name='charge' value={t.charge}
                                                style={{ display: 'flex', flexDirection: 'row' }}
                                                onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}>
                                        <FormControlLabel value={true} control={<Radio />}
                                                          label='En charge'
                                                          disabled={notAbleToChange} />
                                        <FormControlLabel value={false} control={<Radio />}
                                                          label='A vide'
                                                          disabled={notAbleToChange} />
                                    </RadioGroup>
                                </FormControl>
                            </>
                        }

                        {(user.profil.id === 1 || user.profil.id === 2 || user.profil.id === 3) && <MyButton style={'buttonDefault'}
                                                                                     label={'Ajouter EP'}
                                                                                     icon={faPlus}
                                                                                     onClick={() => !ajouterEp ? onOpenElemPatri(t) : false} />}
                        {!notAbleToChange ? <MyButton label={'Supprimer'}
                                                      style={'buttonRejected'}
                                                      icon={faTrashAlt}
                                                      onClick={(event) => deleteSection(event, i, retour)} /> :
                            <div></div>}

                    </div>
                </AccordionSummary>
                <AccordionDetails style={{ marginLeft: '-10px', marginBottom: '-10px', marginTop: '-30px' }}>
                    <Box className={'custom-tab-box'} sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                    }}>
                        <Tabs className={'custom-tabs'} value={value} onChange={handleTabChange}>
                            <Tab className={'custom-tab'} style={css.tab} label='Formulaire' {...a11yProps(0)} />
                            <Tab className={'custom-tab'} style={css.tab} label='Table' {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel className={'pannel-trajet-descr'} style={{ ...css.tabPanel }} value={value} index={0}>
                        {/* region HEADER */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginLeft: '140px',
                        }}>
                            <div style={{
                                display: 'flex',
                            }}>
                                <div>
                                    <MySelect labelClass={'select-label-black'}
                                              name={'road'}
                                              label={'AXE (*)'}
                                              disableClass={true}
                                              style={{ minWidth: '150px' }}
                                              displayLabel={true}
                                              datas={axes}
                                              value={t.road}
                                              disabled={notAbleToChange}
                                              handleChange={(e) => changeSelectValue(e.target.value, setAxeSelected)} />
                                </div>
                                <div style={{ marginLeft: '30px' }}>
                                    {t.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                        <FormControlLabel
                                            control={<Checkbox name='contresens'
                                                               value={t.contresens || false}
                                                               style={{ padding: '10px' }}
                                                               onChange={(e) => handleChangeSectionCheckbox(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                                               checked={t.contresens === true}
                                                               disabled={notAbleToChange} />}
                                            label='Contresens' />
                                    }
                                </div>
                                {t.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                    <div style={{ marginLeft: '30px' }}>
                                        <FormControlLabel
                                            control={<Checkbox name='demontage'
                                                               value={t.demontage || false}
                                                               style={{ padding: '10px' }}
                                                               onChange={(e) => handleChangeSectionCheckbox(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                                               checked={t.demontage === true}
                                                               disabled={notAbleToChange} />}
                                            label='Démontage de matériel' />
                                    </div>
                                }

                                {
                                    tronconInPlanification && profil.profil !== PROFIL.CLIENT && !(requestPassStatus >= REQUEST_PASS_STATUS.VALIDATED && requestPassStatus <= REQUEST_PASS_STATUS.TERMINATED) &&
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        marginLeft: '20px',
                                        color: '#f72424'
                                    }}>/!\ Attention planification(s) existante(s) sur ce tronçon.</div>
                                }
                                {
                                    notAbleToChange && profil.profil === PROFIL.CLIENT && !(requestPassStatus >= REQUEST_PASS_STATUS.VALIDATED && requestPassStatus <= REQUEST_PASS_STATUS.TERMINATED) &&
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: '#f72424'
                                    }}>/!\ Attention planification(s) existante(s) sur ce tronçon, veuillez supprimer la/les demande(s) de passage planifiée(s) correspondante(s)</div>
                                }
                            </div>

                            <div>
                                {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT) &&
                                    <MySelect labelClass={'select-label-black'}
                                              name={'hubSelected'}
                                              label={'CENTRE'}
                                              disableClass={true}
                                              style={{ width: '220px' }}
                                              displayLabel={true}
                                              multiple={true}
                                              datas={centers}
                                              value={centersSelected}
                                              handleChange={(e) => changeSelectValue(e.target.value, setCentersSelected, true)}
                                              disabled={requestPassStatus >= REQUEST_PASS_STATUS.BLOCKED && requestPassStatus <= REQUEST_PASS_STATUS.CANCELLED}
                                    />}
                            </div>
                        </div>
                        {/* endregion */}
                        {/* region SUPERIEUR */}
                        {t.passType === REQUEST_PASS_TYPE.SUPERIEUR &&
                            <>
                                <div className='row' style={{
                                    ...demandePassageStyle.rowIntoPaper,
                                    flexWrap: 'nowrap',
                                    justifyContent: 'flex-start',
                                }}>

                                    <div className='section-libelle' style={{ width: '120px', padding: '5px 15px' }}>
                                        Passage supérieur
                                    </div>

                                    <ControlledTextField
                                        label='COMMUNE (1)'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textField,
                                            marginLeft: '40px',
                                            backgroundColor: 'white',
                                            width: '20%',
                                        }}
                                        autoComplete='off'
                                        name='citySectionEnter'
                                        value={t.citySectionEnter || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                        disabled={notAbleToChange}
                                    />

                                    <ControlledTextField
                                        type={'text'}
                                        name={'roadSectionEnter'}
                                        label={'Route (1)'.toUpperCase()}
                                        disabled={notAbleToChange}
                                        style={{ width: '15%' }}
                                        displayLabel={true}
                                        value={t.roadSectionEnter || ''}
                                        autoComplete='off'
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                    />

                                    <ControlledTextField
                                        type={'text'}
                                        name={'descriptionSectionEnter'}
                                        label={'Description (1)'.toUpperCase()}
                                        disabled={notAbleToChange}
                                        style={{ width: '29%' }}
                                        displayLabel={true}
                                        value={t.descriptionSectionEnter || ''}
                                        autoComplete='off'
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                    />

                                    <ControlledTextField
                                        label='PR'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textFieldShort,
                                            backgroundColor: 'white',
                                            width: '10%',
                                        }}
                                        autoComplete='off'
                                        name='prSectionEnter'
                                        value={t.prSectionEnter || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr', REGEX_PR)}
                                        placeholder={'000.0000'}
                                        inputProps={{ maxLength: 8 }}
                                        disabled={notAbleToChange}
                                    />
                                </div>
                            </>
                        }
                        {/* endregion */}
                        {/* region AUTOROUTE */}
                        {t.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                            <>
                                <div className='row' style={{
                                    ...demandePassageStyle.rowIntoPaper,
                                    justifyContent: 'flex-start',
                                    flexWrap: 'nowrap',
                                }}>
                                    <div className='section-libelle' style={{ width: '120px' }}>Entrée</div>

                                    <MySelect labelClass={'select-label-black'}
                                              name={'pointTypeEnter'}
                                              label={'Type de point (*)'.toUpperCase()}
                                              disableClass={true}
                                              formControlStyle={{
                                                  marginLeft: '40px',
                                                  width: '15%',
                                              }}
                                              style={{ minWidth: '100px' }}
                                              displayLabel={true}
                                              datas={pointTypes}
                                              value={t.pointTypeEnter}
                                              disabled={notAbleToChange}
                                              handleChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                    />

                                    <MySelect labelClass={'select-label-black'}
                                              name={'pointCaracEnter'}
                                              label={'Point caractéristique (1)'.toUpperCase()}
                                              disableClass={true}
                                              formControlStyle={{
                                                  width: '20%',
                                              }}
                                              style={{ minWidth: '100px' }}
                                              displayLabel={true}
                                              datas={pointCaracsEnter}
                                              value={t.pointCaracEnter ?? ''}
                                              disabled={notAbleToChange}
                                              handleChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr', null, listPrEnter)}
                                    />

                                    <ControlledTextField
                                        label='COMMUNE (1)'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textField,
                                            marginLeft: '20px',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            width: '30%',
                                        }}
                                        autoComplete='off'
                                        name='citySectionEnter'
                                        value={t.citySectionEnter || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                        disabled={notAbleToChange}
                                    />

                                    <ControlledTextField
                                        label='PR (1)'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textFieldShort,
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            width: '10%',
                                        }}
                                        autoComplete='off'
                                        name='prSectionEnter'
                                        value={t.prSectionEnter || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr', REGEX_PR)}
                                        placeholder={'000.0000'}
                                        inputProps={{ maxLength: 8 }}
                                        disabled={notAbleToChange}
                                    />
                                </div>

                                <div className='row' style={{
                                    ...demandePassageStyle.rowIntoPaper,
                                    justifyContent: 'flex-start',
                                    flexWrap: 'nowrap',
                                }}>
                                    <div className='section-libelle' style={{ width: '120px' }}>Sortie</div>

                                    <MySelect labelClass={'select-label-black'}
                                              name={'pointTypeExit'}
                                              label={'Type de point (*)'.toUpperCase()}
                                              disableClass={true}
                                              formControlStyle={{
                                                  marginLeft: '40px',
                                                  width: '15%',
                                              }}
                                              style={{ minWidth: '100px' }}
                                              displayLabel={true}
                                              datas={pointTypes}
                                              value={t.pointTypeExit}
                                              disabled={notAbleToChange}
                                              handleChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                    />

                                    <MySelect labelClass={'select-label-black'}
                                              name={'pointCaracExit'}
                                              label={'Point caractéristique (1)'.toUpperCase()}
                                              disableClass={true}
                                              formControlStyle={{
                                                  width: '20%',
                                              }}
                                              style={{ minWidth: '100px' }}
                                              displayLabel={true}
                                              datas={pointCaracsExit}
                                              value={t.pointCaracExit ?? ''}
                                              disabled={notAbleToChange}
                                              handleChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr', null, listPrExit)}
                                    />

                                    <ControlledTextField
                                        label='COMMUNE (1)'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textField,
                                            marginLeft: '20px',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            width: '30%',
                                        }}
                                        autoComplete='off'
                                        name='citySectionExit'
                                        value={t.citySectionExit || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr')}
                                        disabled={notAbleToChange}
                                    />

                                    <ControlledTextField
                                        label='PR (1)'
                                        type='text'
                                        style={{
                                            ...demandePassageStyle.textFieldShort,
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            width: '10%',
                                        }}
                                        autoComplete='off'
                                        name='prSectionExit'
                                        value={t.prSectionExit || ''}
                                        onChange={(e) => handleChangeSection(e, descr, i, retour ? 'descrRetour' : 'descr', REGEX_PR)}
                                        placeholder={'000.0000'}
                                        inputProps={{ maxLength: 8 }}
                                        disabled={notAbleToChange}
                                    />
                                </div>
                            </>}
                        {/* endregion */}
                    </TabPanel>
                    <TabPanel style={css.tabPanel} value={value} index={1}>
                        <div className='row'>
                            {t.elemPatri.length > 0 &&
                                <div style={{
                                    overflow: 'auto',
                                    minHeight: '400px',
                                    width: 'calc(100% - 50px)',
                                    borderTop: '1px solid #4db4da',
                                }}>
                                    <AgGrid
                                        gridName={'ag-grid-heritage-element-' + i}
                                        rowData={t.elemPatri}
                                        columnDefs={elemPatriColumns(i, handleChange, trajetDescr, retour ? 'descrRetour' : 'descr')}
                                        rowHeight={40}
                                        pagination={false}
                                        frameworkComponents={frameworkComponents}
                                        gridOptions={agGridOptions}
                                        setGridOptions={setAgGridOptions}
                                        sortable={false}
                                        style={{
                                            boxSizing: 'border-box',
                                            height: '100%',
                                            width: '100%',
                                        }}
                                    />
                                </div>}
                        </div>
                    </TabPanel>

                </AccordionDetails>
            </Accordion>
        </Paper>);
};

export default TrajetDescrComponent;
